/**
 * Labstep
 *
 * @module components/ProtocolValue/SmartTable/Modal/Content
 * @desc Protocol Condition Modal Content
 */

import { Flex } from 'labstep-web/core/Flex';
import { GridSmartTable as GridSmartTableProtocolValue } from 'labstep-web/grid/SmartTableProtocolValue';
import { EntityView } from 'labstep-web/models/entity-view.model';
import type React from 'react';
import type { ProtocolValueSmartTableModalContentProps } from './types';

export const ProtocolValueSmartTableModalContent: React.FC<
  ProtocolValueSmartTableModalContentProps
> = ({ experimentOrProtocol, entityView, group, entities }) => {
  return (
    <Flex grow data-cy="components/ProtocolValue/Modal/Content">
      <GridSmartTableProtocolValue
        experimentOrProtocol={experimentOrProtocol}
        entityName={EntityView.entityName}
        group={group}
        entities={entities}
        entityView={entityView}
        fullscreen={true}
      />
    </Flex>
  );
};
